module.exports = __webpack_public_path__ + "img/img4.3112bf04.png";